import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import { PageContentShell } from "../../components/layout";
import PrepJobDesignPage from "./ui/PrepJobDesignPage";

const DataPrepDesign = () => (
  <DashboardLayout>
    <DashboardNavbar />
    <PageContentShell>
      <PrepJobDesignPage />
    </PageContentShell>
  </DashboardLayout>
);

export default DataPrepDesign;
